/* eslint-disable no-self-assign */
import React from "react";
import "./Error.css"
import logo from "../../../icons/logo-toolbar.png"

import { useRol } from "../../../Context";

function Error({ error, errorInfo }) {

    const context = useRol();
    const logout = context?.logout || (() => {
        // Logout function not available
        window.location.href = '/sign-in';
    });

    const handleReload = () => {
        logout();
    };

    return (
        <>
            <div className="backgroound">
                <div className="column-direction-error">
                    <div className="contenido-principal-error">
                        <div className="logo-error">
                            <img src={logo} alt="" />
                        </div>
                        <div className="title-error">
                            <div className="text-oops">
                                oops!
                            </div>
                            <div className="numero-error">
                                {error?.number || 'Error!'}
                            </div>
                            <div className="text-message">
                                {error?.toString() || 'Ha ocurrido un error'}
                            </div>
                            <button onClick={handleReload}>Comineza de nuevo</button>
                        </div>
                    </div>
                    <p>{errorInfo?.componentStack || 'Error de Servidor'}</p>
                </div>
            </div>
        </>
    )
}

export { Error }